import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ContractAIApi from '../../Service/ContractAI.api';
import { CheckStringEmpty } from '../../Utils/Common';
import { marked } from 'marked';

const ViewContractDraft = () => {
    const { token } = useParams();
    const [draft, setDraft] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchDraft = async () => {
            try {
                const res = await ContractAIApi.getPublicDraft(token);
                if (res.success) {
                    // Data is stored as a JSON string in the database
                    const parsedData = JSON.parse(res.data.data);
                    const rawContent = parsedData.generatedContract || "No contract content available.";
                    
                    const cleanHtml = (html) => {
                        if (!html) return '';
                        return html.replace(/<span style="color:\s*red;?">(.*?)<\/span>/gi, (match, p1) => {
                            return p1.trim() === '' ? '' : p1;
                        });
                    };

                    setDraft({
                        ...res.data,
                        content: cleanHtml(marked.parse(rawContent))
                    });
                } else {
                    setError("Draft not found or expired.");
                }
            } catch (err) {
                console.error("Fetch error:", err);
                setError("Failed to load draft.");
            } finally {
                setLoading(false);
            }
        };
        if (token) fetchDraft();
    }, [token]);

    if (loading) return <div style={styles.container}>Loading draft...</div>;
    if (error) return <div style={styles.container}>{error}</div>;

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h2 style={styles.title}>{draft.draftName || "Contract Draft"}</h2>
                <span style={styles.badge}>{draft.contractType}</span>
            </div>
            
            <div style={styles.editorContent}>
                {/* Use dangerouslySetInnerHTML if it's HTML, but also wrap in a div that preserves whitespace just in case */}
                <div 
                    className="contract-view-content"
                    dangerouslySetInnerHTML={{ __html: draft.content }} 
                    style={styles.renderedHtml}
                />
            </div>
            
            <div style={styles.footer}>
                <p>This is a read-only view of the contract draft. Please contact the sender to propose changes.</p>
            </div>
        </div>
    );
};

const styles = {
    container: {
        maxWidth: '900px',
        margin: '40px auto',
        padding: '40px',
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
        fontFamily: 'Inter, system-ui, sans-serif'
    },
    header: {
        borderBottom: '2px solid #f3f4f6',
        paddingBottom: '20px',
        marginBottom: '30px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    title: {
        margin: 0,
        color: '#111827',
        fontSize: '24px',
        fontWeight: '700'
    },
    badge: {
        background: '#e0f2fe',
        color: '#0369a1',
        padding: '6px 12px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: '600',
        textTransform: 'uppercase'
    },
    editorContent: {
        lineHeight: '1.6',
        color: '#374151'
    },
    renderedHtml: {
        fontSize: '16px',
        color: '#1f2937',
        lineHeight: '1.8'
    },
    footer: {
        marginTop: '40px',
        paddingTop: '20px',
        borderTop: '1px solid #f3f4f6',
        color: '#6b7280',
        fontSize: '14px',
        textAlign: 'center'
    }
};

export default ViewContractDraft;
